import React from "react";
export enum UserProfiles {
  Admin = "admin",
  Analista = "analista",
  Cliente = "cliente",
}

export interface ProtectedRouteProps {
  children: React.ReactElement;
}

export interface RouteDefinition {
  path: string;
  label: string;
  order?: number;
  profiles?: readonly UserProfiles[];
}

export const RoutesConfig: Record<string, RouteDefinition> = {
  LOGIN: {
    path: "/login",
    label: "Login",
  },
  SPLASH: {
    path: "/",
    label: "Splash",
  },
  HOME: {
    path: "/home",
    label: "Página Inicial",
  },
  DASHBOARD: {
    path: "/dashboard",
    label: "Dashboard",
  },
  REGISTER: {
    path: "/cadastro",
    label: "Cadastro",
  },
  CONFIRMSIGNUP: {
    path: "/confirmar-cadastro",
    label: "Confirmar Cadastro",
  },
  DETALHESPROCESSO: {
    path: "/detalhes-processo",
    label: "Detalhes Processo",
  },
  PROCESSOSPORCLIENTE: {
    path: "/processos-cliente",
    label: "Processor Cliente",
  },
  MEUSPROCESSOS: {
    path: "/meus-processos",
    label: "Meus processos",
  },
  USUARIOS: {
    path: "/usuarios",
    label: "Usuarios",
  },
  CADASTRARUSUARIO: {
    path: "/cadastrar-usuario",
    label: "Cadastrar Usuario",
  },
  REGISTROCLIENTE: {
    path: "/registro-cliente",
    label: "Registro Cliente",
  },
  ASSOCIARADMIN: {
    path: "/associar-admin",
    label: "Associar admin",
  },
  ASSOCIARANALISTA: {
    path: "/associar-analista",
    label: "Associar analista",
  },
  ASSOCIARCLIENTE: {
    path: "/associar-cliente",
    label: "Associar cliente",
  },
} as const;
